import {mock} from './index';

export default {
  userGroupList: () => mock('/admin/userGroup/list'),
  createUserGroup: () => '/admin/userGroup/create',
  modifyUserGroup: () => '/admin/userGroup/modify',
  deleteUserGroup: () => '/admin/userGroup/delete',
  checkNameExist: () => '/admin/name/validator',
  getUserGroupsUserList: () => mock('/admin/userGroup/user/assignedList')
};
